import React from "react";
import InfoTooltip from "Shared/InfoTooltip";
import WithDefaults from "Shared/WithDefaults";
import "./CalculatorRow.scss";

interface CalculatorRowProps {
    className?: string;
    tip?: string;
    title: string;
}

const defaultProps = {
    className: "CalculatorRow",
    tip: "",
};

const formatTitle = (title: string) => {
    if (!title || title === "") return "";
    // Capitalizes text (first letter only)
    return title.charAt(0).toUpperCase() + title.slice(1);
};

const CalculatorRow: React.FunctionComponent<CalculatorRowProps> = ({ children, className, tip, title }: any) => {
    return (
        <div className={className}>
            <div className="CalculatorRow__header">
                {formatTitle(title)}
                {tip && <InfoTooltip className="CalculatorRow__tooltip-icon" text={tip} />}
            </div>
            <div className="CalculatorRow__body">{children}</div>
        </div>
    );
};

export default WithDefaults(defaultProps, CalculatorRow);
